import React from 'react';
import { Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { arrayOf, string, shape, func } from 'prop-types';

import urlEncode from '../urlEncode';

const StationDescription = ({ terms, station, match, showModal }) =>
  station.description.length > 240 ? (
    <div className="description">
      <p>{`${station.description.slice(0, 120)}...`}</p>
      <Button
        as={Link}
        to={`/${match.params.pageType}/${match.params.filterName}/${urlEncode(
          station.name
        )}`}
        onClick={() => showModal()}
        basic
      >
        {terms[3]}
      </Button>
    </div>
  ) : (
    <div className="description">{station.description}</div>
  );

StationDescription.propTypes = {
  terms: arrayOf(string).isRequired,
  station: shape().isRequired,
  match: shape().isRequired,
  showModal: func.isRequired
};

export default StationDescription;
